import lazysizes from 'lazysizes'

const lsConfig = {"lazyClass":"-lazyload","loadedClass":"-lazyloaded","loadingClass":"-lazyloading","preloadClass":"-lazypreload","errorClass":"-lazyerror"}

Object.assign(lazysizes.cfg, lsConfig)
